import classNames from 'classnames';
import React from 'react';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';

var css_248z = ".glob_fontElementMap,.ubrq4{font-family:var(--ricos-font-family,unset)}.ymoPN{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;justify-content:center}[dir] .ymoPN{background:transparent;border:0;cursor:pointer;padding:4px}[dir] .ymoPN:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.ymoPN._0AtDm{fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .ymoPN._0AtDm{background-color:rgba(var(--ricos-action-color-fallback-tuple,2,97,255),.1)}.ymoPN._0AtDm svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.ymoPN.sutHf{opacity:.4}[dir] .ymoPN.sutHf{cursor:default}[dir] .ymoPN.GcGgz:not(._0AtDm):hover{background-color:unset}.ymoPN:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.Layy6{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.Layy6.iTgm0{height:32px;width:32px}._3snf2{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}";
var styles = {"fontElementMap":"ubrq4","toolbarButtonWrapper":"ymoPN","active":"_0AtDm","disabled":"sutHf","mobileToolbarButtonWrapper":"GcGgz","toolbarButton":"Layy6","mobileToolbarButton":"iTgm0","iconTextWrapper":"_3snf2"};
styleInject(css_248z);

const ToolbarButton = React.forwardRef(
  ({
    isMobile = false,
    active,
    disabled,
    tooltip,
    onClick,
    Icon,
    dataHook,
    label
  }, ref) => {
    return /* @__PURE__ */ React.createElement(Tooltip, { key: tooltip, content: tooltip, tooltipOffset: { x: 0, y: -8 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        ref,
        className: classNames(styles.toolbarButtonWrapper, {
          [styles.mobileToolbarButtonWrapper]: isMobile,
          [styles.active]: active,
          [styles.disabled]: disabled
        }),
        onClick: !disabled ? onClick : void 0,
        onMouseDown: (e) => e.preventDefault(),
        "data-hook": dataHook,
        disabled,
        type: "button"
      },
      /* @__PURE__ */ React.createElement("div", { className: classNames(styles.iconTextWrapper, { [styles.mobileToolbarButton]: isMobile }) }, /* @__PURE__ */ React.createElement(Icon, null), label && /* @__PURE__ */ React.createElement("div", null, label))
    ));
  }
);

export { ToolbarButton as default };
//# sourceMappingURL=ToolbarButton.js.map
